import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export const initialState = {
  fullname: '',
  username: '',
  partnerId: '',
  email: '',
  phoneNumber: '',
  partnerIdNonIntegration: '',
  userId: '',
  signed: '',
  authPartnerUrl: '',
  partnerName: '',
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  extraReducers(builder) {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setCurrentUserId: (state, action) => {
      state.userId = action.payload
    },
    setCurrentUserFullname: (state, action) => {
      state.fullname = action.payload
    },
    setCurrentUserPhone: (state, action) => {
      state.phoneNumber = action.payload
    },
    setCurrentUserEmail: (state, action) => {
      state.email = action.payload
    },
    setCurrentUserUsername: (state, action) => {
      state.username = action.payload
    },
    setCurrentUserPartnerId: (state, action) => {
      state.partnerId = action.payload
    },
    setCurrentUserPartnerIdNonIntegration: (state, action) => {
      state.partnerIdNonIntegration = action.payload
    },
    setCurrentUserSigned: (state, action) => {
      state.signed = action.payload
    },
    clearCurrentUserSigned: (state) => {
      state.signed = ''
    },
    setCurrentUserAuthPartnerUrl: (state, action) => {
      state.authPartnerUrl = action.payload
    },
    setCurrentPartnerName: (state, action) => {
      state.partnerName = action.payload
    },
    clearCurrentUserAuthPartnerUrl: (state) => {
      state.authPartnerUrl = ''
    },
  },
})

export const {
  setCurrentUserPartnerIdNonIntegration,
  setCurrentUserPartnerId,
  setCurrentUserUsername,
  setCurrentUserPhone,
  setCurrentUserEmail,
  setCurrentUserId,
  setCurrentUserFullname,
  setCurrentUserSigned,
  setCurrentUserAuthPartnerUrl,
  setCurrentPartnerName,
  clearCurrentUserSigned,
  clearCurrentUserAuthPartnerUrl,
} = userSlice.actions

export default userSlice.reducer
